module.exports = __webpack_public_path__ + "static/media/codeColorSliders.b0061d45.gif";